/* Magic Milk - eigene Story-Leiste. Loest die App-Story ab.

   Mert, 22.08.2026: "Immer noch Fehler in der Story. Ich sehe die neuen
   Stories nicht, plus die Ansicht ist komplett falsch ... Du benutzt nicht
   mehr das Theme von dieser Story, sondern Du duplizierst das. Tu nicht mehr
   die alten Bilder rein, nimm sie komplett raus, dass sie nicht wieder in der
   Story landen. Aber genau wie der Style ist, genau wie das Design ist von
   dieser Story Section mit den drehenden Raedern aussenrum von der
   Story-Vorschau, das machst Du eins zu eins nach."

   WARUM NEU statt weiter flicken: Die Story kam von der App Sternify. Drei
   Anlaeufe (mm-story.js, mm-storyleiste.js, mm-storymodal.js) haben immer nur
   NACHTRAEGLICH korrigiert, was die App baut - Folienbreiten, Bildgroessen,
   Klick-Ziele. Jedes App-Update konnte es wieder umwerfen, und beim zweiten
   Oeffnen kam die alte Bilderfolge zurueck. Diese Datei baut alles selbst:
   eigene Kreise, eigener Ring, eigenes Fenster, eigene Medien. Die
   App-Sektion wird ausgeblendet, nicht mehr angefasst.

   EINS ZU EINS UEBERNOMMEN (am 22.08.2026 an der App gemessen):
     Kreis        56 x 56 px, rund, Innenabstand 5 px
     Grund        rgba(243,233,236,.12) mit blur(12px) saturate(1.55)
     Bild darin   44 x 44 px, rund, cover
     Ring         SVG 100x100, Radius 46, Strichstaerke 3.2, Luecke 12 Grad,
                  offen rgba(229,20,42,.5), gesehen rgba(140,128,134,.26),
                  22 Sekunden je Umdrehung, je Kreis versetzt gestartet

   KEINE ALTEN BILDER: Die frueheren Folgen (mm-box-zutaten, mm-box-ablauf,
   mm-box-siegel, mm-box-vorrat, mm-sorten-*, mm-sommer-flatlay, mm-stick-*)
   sind hier nicht mehr eingetragen. Es laufen nur Motive, die auch sonst
   aktuell im Shop stehen.

   GEMISCHTE FORMATE: Die Motive sind 16:9, 4:5 und 1:1, die Buehne ist 9:16.
   Darum liegt hinter jedem Bild dasselbe Bild unscharf und formatfuellend,
   davor steht es vollstaendig mit `contain`. So wird nichts beschnitten
   (feste Regel) und es sieht trotzdem gefuellt aus statt schwarz umrandet. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/';
  var DAUER = 5000;
  var ruhig = false;
  try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* 22.08.2026, Mert: "versand videos, pakete (benenn die story zu shipping) /
     produkte story / influencer story (tiktok nennen) / feedbacks story
     (vorher nachher, chat screenshots) / dann die passenden sachen rein tun
     und immer mit emojis passend z.B. shipping \ud83d\udce6".

     WOHER DIE BILDER KOMMEN: aus `Desktop/Storys (TT, Insta)/Bereit/` - das
     ist der Bestand, den die Instagram-Routine bereits GESCHWAERZT hat
     (Anschriften, Telefonnummern, Rabattcodes). Alle 1080x1920, also genau
     Story-Format; nichts muss beschnitten werden.
     Sie liegen als Theme-Dateien (`mm-st-*.jpg`), damit sie mit dem Theme
     ausgeliefert werden.

     BEWUSST NICHT GENOMMEN: die vier fertigen Produkt-Grafiken aus
     `Bereit/Produktfotos`. Sie tragen oben und unten breite Schwaerzungs-
     balken - in einer Story sieht das nach Fehler aus. Fuer "Produkte" laufen
     stattdessen die Motive, die auch sonst im Shop stehen. */
  /* 24.08.2026 FEHLER GEFUNDEN (Mert: "fragezeichen fehler hier" - der
     TikTok-Kreis zeigte ein leeres Platzhalter-Symbol): Hier stand der
     Theme-Ordner fest verdrahtet als "t/28". Shopify vergibt beim
     Veroeffentlichen einer Theme-Kopie eine NEUE Nummer - live ist inzwischen
     t/29, alle t/28-Adressen liefern 404. Betraf jedes Bild und Video, das
     erst nach dem Wechsel dazukam.
     Der Ordner wird jetzt zur Laufzeit aus einer beliebigen bereits geladenen
     Theme-Datei ausgelesen, statt ihn zu raten. Damit bricht das beim
     naechsten Theme-Wechsel nicht wieder. */
  var THEMA = (function () {
    var k = document.querySelectorAll('script[src],link[href]');
    for (var i = 0; i < k.length; i++) {
      var u = k[i].src || k[i].href || '';
      var m = u.match(/\/cdn\/shop\/t\/\d+\/assets\//);
      if (m) return u.slice(0, u.indexOf(m[0]) + m[0].length);
    }
    return 'https://magicmilk.de/cdn/shop/t/29/assets/';
  })();

  /* 24.08.2026, Mert nach dem morgendlichen Rueckschlag: "Du solltest nicht
     einfach neu machen. Ich will die Version, die ich hatte." - zurecht: ein
     erster Versuch hatte hier eigene Bildunterschriften erfunden und JEDE
     unverdrahtet gefundene Datei eingebaut, statt genau den Endstand vom
     23.08. wiederherzustellen. Dieser Endstand steht im eigenen
     Beobachtungsprotokoll (claude-mem) mit Zeitstempeln:
       Shipping  13:38 Uhr: "8 aktive Folien (1 Bild, 7 Videos)"
       Produkte  07:55 Uhr: "1 Video, 8 Bilder" (die 4 einfachen Fotos +
                 vier durchgestaltete Grafiken - siehe Datei-Kopf oben,
                 Zeile 54: die wurden bewusst NICHT genommen, wegen breiter
                 Schwaerzungsbalken oben/unten)
       TikTok    13:48 Uhr: 10 Folien, nachdem "Hediyah" (mm-story-tt-9)
                 und zuvor "2. story" (mm-story-tt-1) entfernt wurden
       Feedbacks 16:05 Uhr: "5 Folien (mm-st-fb-7, -1, -2, -3, -6)",
                 mm-st-fb-4 ("Nach ein paar Tagen") entfernt
     Genau das steht jetzt wieder hier - nicht mehr, nicht weniger. */
  var STORYS = [
    { kreis: THEMA + 'mm-st-kreis-shipping.jpg', titel: '\ud83d\udce6 Shipping',
      /* 24.08.2026, Mert: "story vorschau die videos muessen abspielen in der
         vorschau". Die quadratischen 176x176-Zuschnitte lagen laengst im Theme
         (mm-p2-*.mp4), wurden aber nicht genutzt. Quadratisch heisst: im Kreis
         ist nie ein Rand zu sehen - Merts Vorgabe "aussenrum darf man nicht
         sehen bei vorschau". */
      film: ['mm-p2-vsv-1.mp4', 'mm-p2-vsv-3.mp4', 'mm-p2-vsv-4.mp4', 'mm-p2-vsv-5.mp4'],
      ziel: '/policies/shipping-policy',
      folgen: [
        { vollVideo: CDN + 'mm-story-shipping-1.mp4',
          voll: THEMA + 'mm-st-poster-shipping-1.jpg',
          kopf: '\ud83d\udce6 Heute wird gepackt',
          text: 'Direkt aus unserem Lager in Deutschland.' },
        /* 25.08.2026, Mert: "raus aus der story damit mit dem versand bild"
           (Bildschirmfoto der Folie "Bereit zum Versand", mm-st-vs-1.jpg -
           Paketstapel am DHL-Schalter). Datei bleibt im Theme liegen. */
        { vollVideo: THEMA + 'mm-story-vs-1.mp4', voll: THEMA + 'mm-st-poster-vs-1.jpg',
          kopf: '\ud83d\udce6 Im Lieferwagen', text: 'Beladen fuer die Tour.' },
        { vollVideo: THEMA + 'mm-story-vs-2.mp4', voll: THEMA + 'mm-st-poster-vs-2.jpg',
          kopf: '\ud83d\udce6 Sauber gestapelt', text: 'Jedes Paket an seinem Platz.' },
        { vollVideo: THEMA + 'mm-story-vs-3.mp4', voll: THEMA + 'mm-st-poster-vs-3.jpg',
          kopf: '\ud83d\ude9a Verladen', text: 'Es geht direkt in den Wagen.' },
        { vollVideo: THEMA + 'mm-story-vs-4.mp4', voll: THEMA + 'mm-st-poster-vs-4.jpg',
          kopf: '\ud83d\udce6 Startklar', text: 'Bereit fuer die naechste Tour.' },
        { vollVideo: THEMA + 'mm-story-vs-5.mp4', voll: THEMA + 'mm-st-poster-vs-5.jpg',
          kopf: '\ud83d\udce6 Volle Ladung', text: 'So viel geht heute raus.' },
        { vollVideo: THEMA + 'mm-story-vs-6.mp4', voll: THEMA + 'mm-st-poster-vs-6.jpg',
          kopf: '\ud83d\udce6 Fertig verpackt', text: 'Startklar fuer den Versand.' }
      ] },

    /* Belegt aus dem Protokoll vom 23.08. 07:55 Uhr: "Produkte-Story:
       1 Video, 8 Bilder" - also die vier Produktfotos PLUS die vier
       durchgestalteten Grafiken plus das Zubereitungsvideo. Der aeltere
       Kopfkommentar dieser Datei ("Produktfotos bewusst nicht genommen")
       ist damit ueberholt; er stammt von vor dieser Erweiterung. */
    { kreis: CDN + 'magic-milk-for-x5-standard-1.png?width=150', titel: '\ud83e\udd5b Produkte',
      film: ['mm-p2-prv-1.mp4'],
      ziel: '/collections/all',
      folgen: [
        { bild: 'magic-milk-for-x5-standard-1.png', kopf: '\ud83e\udd5b Standard',
          text: 'Neutral im Geschmack, der Klassiker.' },
        { bild: 'mm-stick-erdbeere.jpg', kopf: '\ud83c\udf53 Erdbeere',
          text: 'Ein Stick pro Tag.' },
        { bild: 'mm-stick-nuss.jpg', kopf: '\ud83e\udd5c Nuss & Creamy',
          text: 'Pistazie, Erdnuss, Milchpulver.' },
        { bild: 'set2-standard-motiv.png', kopf: '\ud83d\udce6 Spar-Set',
          text: 'Zwei Packungen, ein Preis.' },
        { voll: THEMA + 'mm-st-produkt-1.jpg', kopf: '\ud83e\udd5b Drei Sorten, eine Routine',
          text: 'Ein Stick pro Tag.' },
        { voll: THEMA + 'mm-st-produkt-2.jpg', kopf: '\ud83e\udd5b Geschmack Neutral',
          text: 'FOR X5 Magic Milk.' },
        { voll: THEMA + 'mm-st-produkt-3.jpg', kopf: '\ud83c\udf53 Geschmack Erdbeere',
          text: 'FOR X5 Magic Milk.' },
        { voll: THEMA + 'mm-st-produkt-4.jpg', kopf: '\ud83e\udd5c Nuss & Creamy',
          text: 'Pro Milk ZeroTermo.' },
        { vollVideo: THEMA + 'mm-story-pr-1.mp4', voll: THEMA + 'mm-st-poster-pr-1.jpg',
          kopf: '\ud83e\udd5b Einmal umruehren', text: 'So einfach geht die Zubereitung.' }
      ] },

    /* REIHENFOLGE, belegt aus dem Beobachtungsprotokoll vom 23.08. 06:51 Uhr
       (Mert damals: "1. video chanel, 4. video: das video im 1.bild, alle
       anderen so lassen"):
         1. Chanel  2. tt-1  3. tt-2  4. tt-6  5.-8. tt-3/4/5/7/8
         9. tt-9 (Hediyah)  10. tt-10  11. tt-11
       Danach zwei Entfernungen durch Mert:
         08:00 "2. story raus"  -> tt-1 weg (war dieselbe Creatorin wie Chanel)
         13:48 "raus damit"     -> tt-9 (Hediyah) weg
       Bleiben 10 Folien in genau dieser Abfolge. Chanel liegt NICHT im Theme,
       sondern als Shopify-Datei - deshalb die volle CDN-Adresse. */
    { kreis: THEMA + 'mm-st-kreis-ugc2.jpg', titel: '\ud83c\udfac TikTok',
      film: ['mm-p2-tt-1.mp4', 'mm-p2-tt-2.mp4', 'mm-p2-tt-3.mp4', 'mm-p2-tt-4.mp4'],
      ziel: '/collections/all',
      folgen: [
        { vollVideo: 'https://cdn.shopify.com/videos/c/vp/c6ecb45f93444e71b4ad77132cd9ac7b/c6ecb45f93444e71b4ad77132cd9ac7b.HD-720p-1.6Mbps-85015394.mp4',
          voll: THEMA + 'mm-st-poster-tt-1.jpg',
          kopf: '\ud83c\udfac Chanel', text: 'Eine Million Follower auf TikTok.' },
        { vollVideo: THEMA + 'mm-story-tt-2.mp4',
          voll: THEMA + 'mm-st-poster-tt-2.jpg',
          kopf: '\ud83c\udfac Echte Aufnahme',
          text: 'Echte Aufnahmen aus der Community.' },
        { vollVideo: THEMA + 'mm-story-tt-6.mp4',
          voll: THEMA + 'mm-st-poster-tt-6.jpg',
          kopf: '\ud83c\udfac Von euch gedreht', text: 'Selbst gedreht, selbst erlebt.' },
        { vollVideo: THEMA + 'mm-story-tt-3.mp4',
          voll: THEMA + 'mm-st-poster-tt-3.jpg',
          kopf: '\ud83c\udfac Erfahrungsbericht', text: 'Echte Erfahrung.' },
        { vollVideo: THEMA + 'mm-story-tt-4.mp4',
          voll: THEMA + 'mm-st-poster-tt-4.jpg',
          kopf: '\ud83c\udfac Mitten im Alltag', text: 'Einer unserer Creator zeigt es.' },
        { vollVideo: THEMA + 'mm-story-tt-5.mp4',
          voll: THEMA + 'mm-st-poster-tt-5.jpg',
          kopf: '\ud83c\udfac Von unseren Creatorn', text: 'Noch eine echte Aufnahme.' },
        { vollVideo: THEMA + 'mm-story-tt-7.mp4',
          voll: THEMA + 'mm-st-poster-tt-7.jpg',
          kopf: '\ud83c\udfac Noch eins', text: 'So laeuft es bei unseren Creatorn.' },
        { vollVideo: THEMA + 'mm-story-tt-8.mp4',
          voll: THEMA + 'mm-st-poster-tt-8.jpg',
          kopf: '\ud83c\udfac Zum Schluss', text: 'Aus unserer Community.' },
        { vollVideo: THEMA + 'mm-story-tt-10.mp4',
          voll: THEMA + 'mm-st-poster-tt-10.jpg',
          kopf: '\ud83c\udfac Anastasija', text: 'Echte Aufnahme.' },
        { vollVideo: THEMA + 'mm-story-tt-11.mp4',
          voll: THEMA + 'mm-st-poster-tt-11.jpg',
          kopf: '\ud83c\udfac OC Zusammenarbeit', text: 'Noch ein Video aus der Community.' }
      ] },

    { kreis: THEMA + 'mm-st-kreis-feedback.jpg', titel: '\ud83d\udcac Feedbacks',
      ziel: '/collections/all',
      folgen: [
        { voll: THEMA + 'mm-st-fb-7.jpg', kopf: '\ud83d\udcac Vorher / Nachher',
          text: 'Ruecktmeldung eines Kunden.' },
        { voll: THEMA + 'mm-st-fb-1.jpg', kopf: '\ud83d\udcac Aus dem Chat',
          text: 'Echte Rueckmeldung, dritte Packung bestellt.' },
        { voll: THEMA + 'mm-st-fb-2.jpg', kopf: '\ud83d\udcac Angekommen',
          text: 'Rueckmeldung aus dem Chat.' },
        { voll: THEMA + 'mm-st-fb-3.jpg', kopf: '\ud83d\udcac Positiv ueberrascht',
          text: 'Rueckmeldung nach ein paar Tagen.' },
        { voll: THEMA + 'mm-st-fb-6.jpg', kopf: '\ud83d\udcac Aus dem Support',
          text: 'Antworten aus unserem Chat.' }
      ] }
  ];

  var K = 'cubic-bezier(.22,.61,.36,1)';

  var css = [
    /* --- Leiste ---------------------------------------------------------- */
    /* 22.08.2026, Mert: "weisser hintergrund". Die Leiste sass als dunkles Band
       zwischen weisser Kopfzeile und weisser Sektion darunter. Jetzt weiss -
       dadurch mussten auch Kreisgrund, Name und der graue Ringbogen kippen,
       sonst waeren sie auf Weiss unsichtbar gewesen. */
    /* 24.08.2026 ERNEUT AUFGETRETEN: '.page-wrapper' ist eine Spalten-Flexbox
     mit fester Hoehe; 'overflow:hidden' setzt die automatische Mindesthoehe
     eines Flex-Kindes auf 0, wodurch #mmSE auf ~26px zusammengedrueckt wird -
     nur am Rechner sichtbar (Mert: "story design stimmt nicht"), am Handy
     unauffaellig. War am 22.08. schon einmal behoben, ist beim Umbau der
     Datei seither wieder verlorengegangen. Deshalb dieses Mal fest im
     Kommentar verankert, nicht nur im Kopf. */
    '#mmSE{width:100%;flex:0 0 auto;box-sizing:border-box;background:#FFFFFF;margin:0;',
    'padding:12px 0 14px;overflow:hidden}',
    '#mmSE *{box-sizing:border-box}',
    /* 22.08.2026, Mert: "oben ist zugeschnitten ... das darf hier nicht am rand
       zugeschnitten sein, alle 4 auf ein fleck sauber".
       ZWEI URSACHEN, beide behoben:
       1. Die Bahn war ein Rollbereich mit `overflow-y:hidden`. Der Ring steht
          7 px ueber dem Kreis - und genau die hat der Rollbereich oben
          abgeschnitten. Jetzt 10 px Innenabstand oben und kein Beschnitt mehr.
       2. Vier Kreise nebeneinander in einer Rollbahn passten bei 375 px nicht
          ins Bild, der vierte hing halb draussen. Jetzt ein Raster mit genau
          vier gleichen Spalten - alle vier sitzen immer vollstaendig da,
          ohne Rollen. */
    '#mmSEBahn{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));',
    'gap:6px;padding:10px 12px 4px;justify-items:center;align-items:start}',
    '@media(min-width:900px){#mmSEBahn{gap:12px;padding:10px 20px 4px;',
    'max-width:900px;margin:0 auto}}',

    /* 24.08.2026, Mert: "texte muessen gesunden abstand unter den kreisen
       haben". Der Ring laeuft 7 px ausserhalb des Kreises - bei 6 px Abstand
       klebte die Beschriftung fast daran. 12 px setzen den Namen sichtbar ab,
       ohne die Leiste hoeher zu machen als noetig. */
    /* 25.08.2026, Mert: "story animation ploppen ... wie davor". Die Werte
       stehen im Beobachtungsprotokoll vom 23.08.: vier Kreise, 95 ms Versatz,
       je 620 ms, der Name des vierten 180 ms spaeter - fertig nach 1085 ms.
       Genau darauf ist der Logo-Fall in mm-textanim.js abgestimmt (1,15 s).
       Die Klasse `fertig` wird nach dem Lauf gesetzt: ohne sie bleiben die
       Kreise stehen, wenn die Animation pausiert wird (Regel 23.08.). */
    '@keyframes mmSEPlopp{0%{opacity:0;transform:scale(.6) translateY(10px)}',
    '60%{opacity:1;transform:scale(1.06) translateY(0)}',
    '100%{opacity:1;transform:scale(1) translateY(0)}}',
    '@keyframes mmSENameRein{from{opacity:0;transform:translateY(6px)}',
    'to{opacity:1;transform:none}}',
    '.mmSEStueck .mmSEKreis{animation:mmSEPlopp .62s cubic-bezier(.34,1.5,.5,1) both;',
    'animation-delay:calc(var(--mmSEi,0) * 95ms)}',
    '.mmSEStueck .mmSEName{animation:mmSENameRein .42s ease both;',
    'animation-delay:calc(var(--mmSEi,0) * 95ms + 180ms)}',
    /* Nach dem Lauf steht alles fest - nichts kann unsichtbar einfrieren. */
    '.mmSEStueck.fertig .mmSEKreis,.mmSEStueck.fertig .mmSEName{',
    'animation:none!important;opacity:1!important;transform:none!important}',
    '@media(prefers-reduced-motion:reduce){',
    '.mmSEStueck .mmSEKreis,.mmSEStueck .mmSEName{animation:none!important}}',
    '.mmSEStueck{display:flex;flex-direction:column;align-items:center;gap:12px;',
    'width:100%;max-width:86px;background:none;border:0;padding:0;',
    'cursor:pointer;font:inherit;color:inherit}',
    /* Kreis - Masse und Glas exakt wie in der App gemessen */
    '.mmSEKreis{position:relative;width:56px;height:56px;flex:0 0 auto;',
    'border-radius:50%;',
    'padding:5px;background:rgba(21,16,19,.07);',
    '-webkit-backdrop-filter:blur(12px) saturate(1.55);',
    'backdrop-filter:blur(12px) saturate(1.55);',
    'transition:transform .3s ' + K + '}',
    '@media(hover:hover){.mmSEStueck:hover .mmSEKreis{transform:scale(1.06)}}',
    /* 24.08.2026: der Vorschaufilm liegt genau auf dem Standbild. Er blendet
       erst auf, wenn er wirklich laeuft - so gibt es kein schwarzes Loch,
       falls er nicht startet. */
    '.mmSEVor{position:absolute;inset:5px;width:calc(100% - 10px);',
    'height:calc(100% - 10px);border-radius:50%;object-fit:cover;',
    'opacity:0;transition:opacity .35s ease;pointer-events:none}',
    '.mmSEVor.laeuft{opacity:1}',
    '.mmSEKreis img{width:100%;height:100%;border-radius:50%;object-fit:cover;',
    'display:block}',
    /* Ring - Geometrie und Farben aus der App uebernommen */
    /* 22.08.2026, Mert: "fehler ueberlappt". GEMESSEN: mit `inset:-6px` blieb
       das SVG 56x56 - genau so gross wie der Kreis -, der Ring lief dadurch
       ueber die Bildkante. Jetzt feste Masse: 70x70, um 7 px versetzt. Der
       Ringpfad liegt bei 46/50 der Box, also 64,4 px Durchmesser - das sind
       9 px Luft zum 46-px-Bild auf jeder Seite. */
    /* 22.08.2026, dritter Anlauf und diesmal die echte Ursache: Das Theme
       setzt `svg{max-width:100%}`. Der Kreis ist 56 px breit, also wurde mein
       70-px-Ring auf 56 gestutzt - Hoehe 70, Breite 56, aus dem Kreis wurde
       eine Ellipse. Genau das sah Mert als "fehler ueberlappt".
       `max-width:none` hebt den Deckel auf. */
    '.mmSERing{position:absolute;top:-7px;left:-7px;',
    'width:70px!important;height:70px!important;',
    'max-width:none!important;min-width:0;',
    'pointer-events:none;overflow:visible}',
    '.mmSERing g{transform-origin:50px 50px;animation:mmSEDreh 22s linear infinite}',
    '.mmSERing.ruht g{animation:none}',
    '@keyframes mmSEDreh{from{transform:rotate(0)}to{transform:rotate(360deg)}}',
    '.mmSERing path{fill:none;stroke-width:3.2;stroke-linecap:round;',
    'transition:stroke .45s ease}',
    /* 24.08.2026, Mert (Referenzbild vom 23.08.): der Ring war je Story
       eigenfarbig - orange/rot/pink/lila - und ist auf ein einheitliches,
       blasses Rot zusammengeschrumpft. Farbe kommt jetzt wieder je Kreis
       ueber --rf mit, gesetzt in ring(). */
    '.mmSERing path.offen{stroke:var(--rf,rgba(229,20,42,.5))}',
    '.mmSERing path.fertig{stroke:rgba(21,16,19,.2)}',
    /* "Feedbacks" wurde vorher abgeschnitten. Jetzt darf der Name umbrechen. */
    '.mmSEName{font-size:.66rem;line-height:1.3;text-align:center;padding-top:2px;',
    'color:rgba(21,16,19,.7);max-width:100%;word-break:break-word}',
    '@media(prefers-reduced-motion:reduce){.mmSERing g{animation:none}}',

    /* --- Fenster --------------------------------------------------------- */
    '#mmSEFenster{position:fixed;inset:0;z-index:100000;display:none;',
    'background:#080607;align-items:center;justify-content:center;',
    'overscroll-behavior:contain}',
    '#mmSEFenster.an{display:flex}',
    '#mmSEBuehne{position:relative;width:min(100%,460px);height:100svh;',
    'max-height:100svh;background:#080607;overflow:hidden;',
    'display:flex;align-items:center;justify-content:center}',
    '@media(min-width:620px){#mmSEBuehne{height:min(92svh,820px);',
    'border-radius:18px;box-shadow:0 30px 80px rgba(0,0,0,.7)}}',

    /* Unscharfer Grund + vollstaendiges Bild davor - nichts wird beschnitten */
    '.mmSEFolie{position:absolute;inset:0;opacity:0;',
    'transition:opacity .35s ease}',
    '.mmSEFolie.da{opacity:1}',
    '.mmSEGrund{position:absolute;inset:0;overflow:hidden}',
    '.mmSEGrund img{width:100%;height:100%;object-fit:cover;display:block;',
    'transform:scale(1.2);filter:blur(30px) saturate(1.2) brightness(.55)}',
    '.mmSEMedium{position:absolute;inset:0;display:flex;',
    'align-items:center;justify-content:center}',
    '.mmSEMedium img,.mmSEMedium video{width:100%;height:100%;',
    'object-fit:contain;display:block}',

    '#mmSEOben{position:absolute;top:0;left:0;right:0;z-index:3;',
    'padding:12px 12px 0;background:linear-gradient(rgba(0,0,0,.62),transparent)}',
    '#mmSEBalken{display:flex;gap:4px}',
    '.mmSEB{flex:1;height:3px;border-radius:2px;background:rgba(255,255,255,.28);',
    'overflow:hidden}',
    '.mmSEB i{display:block;height:100%;width:0;border-radius:2px;background:#E5142A}',
    '#mmSEKopf{display:flex;align-items:center;gap:10px;padding:11px 2px 0;color:#fff}',
    '#mmSETitel{flex:1;font-size:.9rem;font-weight:600;min-width:0;',
    'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '#mmSEKopf button{border:0;background:rgba(255,255,255,.14);color:#fff;',
    'cursor:pointer;width:34px;height:34px;border-radius:50%;display:grid;',
    'place-items:center;font-size:15px;line-height:1;',
    '-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);',
    'transition:background .2s ease}',
    '#mmSEKopf button:hover{background:rgba(255,255,255,.26)}',
    '#mmSEKopf button:focus-visible{outline:2px solid #E5142A;outline-offset:2px}',

    '#mmSEUnten{position:absolute;left:0;right:0;bottom:0;z-index:3;',
    'padding:56px 18px 26px;color:#fff;',
    'background:linear-gradient(transparent,rgba(0,0,0,.78))}',
    '#mmSEUnten h3{margin:0 0 5px;font-size:1.3rem;font-weight:800;',
    'letter-spacing:-.02em}',
    '#mmSEUnten p{margin:0 0 14px;font-size:.92rem;color:rgba(255,255,255,.72)}',
    /* 22.08.2026, Mert: "button nicht rot, moderner." Glasflaeche statt
       roter Flaeche - dieselbe Sprache wie die Knoepfe im uebrigen Shop und im
       Einklang mit der Regel "kein rotes KI-Design": aktive Zustaende als
       Glas, Rot nur als Akzent. */
    '#mmSEUnten a{display:inline-flex;align-items:center;gap:8px;color:#fff;',
    'text-decoration:none;font-size:.92rem;font-weight:600;padding:13px 24px;',
    'border-radius:999px;border:1px solid rgba(255,255,255,.32);',
    'background:rgba(255,255,255,.12);',
    '-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);',
    'transition:background .25s ease,border-color .25s ease}',
    '#mmSEUnten a:hover{background:rgba(255,255,255,.2);',
    'border-color:rgba(255,255,255,.5)}',
    '#mmSEUnten a::after{content:"\\2192";opacity:.8}',
    '.mmSETipp{position:absolute;top:0;bottom:0;width:34%;z-index:2;cursor:pointer}',
    '.mmSETipp.links{left:0}.mmSETipp.rechts{right:0}'
  ].join('');

  var gesehen = {};
  var fenster, balkenEl, titelEl, buehneEl, untenEl, knopfPause, knopfTon;
  /* 24.08.2026: Ton-Wunsch des Besuchers. Gilt fuer die ganze Sitzung, damit
     man ihn nicht bei jeder Folie neu einschalten muss. Start immer stumm -
     sonst laesst kein Browser das Video von allein anlaufen. */
  var tonAn = false;

  /* Setzt den Ton am laufenden Video und bringt den Knopf auf denselben Stand. */
  function tonSetzen() {
    var v = buehneEl ? buehneEl.querySelector('video') : null;
    if (v) {
      v.muted = !tonAn;
      v.volume = 1;
      /* Nach dem Entstummen laeuft ein pausiertes Video sonst nicht weiter. */
      if (tonAn && v.paused && !pausiert) { try { v.play(); } catch (e) {} }
    }
    if (knopfTon) {
      knopfTon.innerHTML = tonAn ? '&#128266;' : '&#128263;';
      knopfTon.setAttribute('aria-pressed', tonAn ? 'true' : 'false');
      knopfTon.setAttribute('aria-label', tonAn ? 'Ton ausschalten' : 'Ton einschalten');
    }
  }
  var folge = [], nr = 0, pausiert = false, t0 = 0, rest = DAUER, raf = null;
  var aktKreis = null, aktTitel = '';

  function stil() {
    if (document.getElementById('mmSE-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmSE-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function jetzt() {
    return (window.performance && performance.now) ? performance.now() : +new Date();
  }

  /* Reihenfolge = Story-Reihenfolge: Shipping orange, Produkte rot, TikTok
     pink, Feedbacks lila - wie im Referenzbild vom 23.08. */
  var RINGFARBEN = ['#F2954B', '#E5142A', '#FF4B7E', '#8E6BFF'];

  /* --- Ring zeichnen (Geometrie aus der App) ------------------------------ */
  function ring(anzahl, gesehenSet, versatz) {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'mmSERing');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    /* 22.08.2026 GEMESSEN: ueber CSS allein kam das SVG auf 56x70 - die Hoehe
       griff, die Breite nicht. Aus dem Kreis wurde eine Ellipse, und genau das
       sah Mert als "fehler ueberlappt". Die Masse stehen darum als Attribut
       direkt am SVG; daran kommt kein Stilblatt vorbei. */
    svg.setAttribute('width', '70');
    svg.setAttribute('height', '70');
    svg.style.setProperty('--rf', RINGFARBEN[versatz % RINGFARBEN.length]);
    var g = document.createElementNS(NS, 'g');
    var luecke = anzahl > 1 ? 12 : 0;
    var seg = (360 - luecke * anzahl) / anzahl;
    var r = 46, fertig = 0;
    for (var i = 0; i < anzahl; i++) {
      var a1 = (-90 + i * (seg + luecke)) * Math.PI / 180;
      var a2 = (-90 + i * (seg + luecke) + seg) * Math.PI / 180;
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', 'M ' + (50 + r * Math.cos(a1)).toFixed(2) + ' ' +
        (50 + r * Math.sin(a1)).toFixed(2) + ' A ' + r + ' ' + r + ' 0 ' +
        (seg > 180 ? 1 : 0) + ' 1 ' + (50 + r * Math.cos(a2)).toFixed(2) + ' ' +
        (50 + r * Math.sin(a2)).toFixed(2));
      var ist = !!(gesehenSet && gesehenSet[i]);
      if (ist) fertig++;
      p.setAttribute('class', ist ? 'fertig' : 'offen');
      g.appendChild(p);
    }
    g.style.animationDelay = (-versatz * 2.6) + 's';
    svg.appendChild(g);
    if (fertig === anzahl) svg.setAttribute('class', 'mmSERing ruht');
    return svg;
  }

  function ringNeu(stueck, idx) {
    var kreis = stueck.querySelector('.mmSEKreis');
    var alt = kreis.querySelector('.mmSERing');
    if (alt) alt.remove();
    kreis.appendChild(ring(STORYS[idx].folgen.length, gesehen[STORYS[idx].titel], idx));
  }

  /* --- Fenster ------------------------------------------------------------ */
  function huelle() {
    if (document.getElementById('mmSEFenster')) return;
    var d = document.createElement('div');
    d.id = 'mmSEFenster';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.innerHTML =
      '<div id="mmSEBuehne">' +
        '<div id="mmSEHalter"></div>' +
        '<span class="mmSETipp links"></span><span class="mmSETipp rechts"></span>' +
        '<div id="mmSEOben">' +
          '<div id="mmSEBalken"></div>' +
          '<div id="mmSEKopf"><span id="mmSETitel"></span>' +
            /* 24.08.2026, Mert: "story stumm taste fehlt". Videos starten
               weiterhin stumm - anders laesst kein Browser sie von selbst
               anlaufen. Wer den Ton will, tippt hier. Die Wahl gilt fuer die
               ganze Sitzung, nicht nur fuer die eine Folie. */
            '<button id="mmSETon" type="button" aria-label="Ton einschalten" ' +
              'aria-pressed="false">&#128263;</button>' +
            '<button id="mmSEPause" type="button" aria-label="Pause">&#10073;&#10073;</button>' +
            '<button id="mmSEZu" type="button" aria-label="Schließen">&#10005;</button>' +
          '</div>' +
        '</div>' +
        '<div id="mmSEUnten"></div>' +
      '</div>';
    document.body.appendChild(d);
    fenster = d;
    balkenEl = d.querySelector('#mmSEBalken');
    titelEl = d.querySelector('#mmSETitel');
    buehneEl = d.querySelector('#mmSEHalter');
    untenEl = d.querySelector('#mmSEUnten');
    knopfPause = d.querySelector('#mmSEPause');
    knopfTon = d.querySelector('#mmSETon');
    d.querySelector('#mmSEZu').addEventListener('click', zu);
    knopfPause.addEventListener('click', function () { pausiert ? weiter() : anhalten(); });
    knopfTon.addEventListener('click', function (e) {
      e.stopPropagation();
      tonAn = !tonAn;
      tonSetzen();
    });
    d.querySelector('.mmSETipp.links').addEventListener('click', function () { springe(-1); });
    d.querySelector('.mmSETipp.rechts').addEventListener('click', function () { springe(1); });
    d.addEventListener('click', function (e) { if (e.target === d) zu(); });
    document.addEventListener('keydown', function (e) {
      if (!fenster.classList.contains('an')) return;
      if (e.key === 'Escape') zu();
      if (e.key === 'ArrowRight') springe(1);
      if (e.key === 'ArrowLeft') springe(-1);
    });
  }

  function zeige(i) {
    if (i < 0 || i >= folge.length) { zu(); return; }
    nr = i;
    if (!gesehen[aktTitel]) gesehen[aktTitel] = {};
    gesehen[aktTitel][i] = true;
    if (aktKreis) ringNeu(aktKreis.stueck, aktKreis.idx);

    var s = folge[i];
    var quelle = s.voll || (CDN + (s.bild || ''));
    buehneEl.innerHTML =
      '<div class="mmSEFolie">' +
        '<span class="mmSEGrund"><img src="' + quelle + '" alt="" aria-hidden="true"></span>' +
        '<span class="mmSEMedium">' +
          ((s.video || s.vollVideo)
            ? '<video src="' + (s.vollVideo || (CDN + s.video)) + '" poster="' + quelle + '" ' +
              'muted playsinline autoplay preload="auto"></video>'
            : '<img src="' + quelle + '" alt="' + s.kopf + '">') +
        '</span>' +
      '</div>';
    var f = buehneEl.querySelector('.mmSEFolie');
    window.requestAnimationFrame(function () { f.classList.add('da'); });
    /* Jede neue Folie uebernimmt die Ton-Entscheidung des Besuchers. */
    tonSetzen();

    untenEl.innerHTML = '<h3>' + s.kopf + '</h3><p>' + s.text + '</p>' +
      '<a href="' + (aktKreis ? STORYS[aktKreis.idx].ziel : '/collections/all') + '">Jetzt ansehen</a>';

    [].slice.call(balkenEl.querySelectorAll('i')).forEach(function (b, j) {
      b.style.width = j < i ? '100%' : (j > i ? '0%' : b.style.width);
    });
    /* Ein Video laeuft so lange, wie es dauert - sonst feste Standzeit. */
    var v = buehneEl.querySelector('video');
    rest = DAUER;
    if (v) {
      v.addEventListener('loadedmetadata', function () {
        if (v.duration && isFinite(v.duration)) { rest = v.duration * 1000; starte(rest); }
      });
    }
    starte(rest);
  }

  var laenge = DAUER;
  function starte(d) {
    stoppe();
    if (ruhig) return;
    laenge = d || DAUER;
    pausiert = false;
    knopfPause.innerHTML = '&#10073;&#10073;';
    t0 = jetzt();
    var balken = balkenEl.querySelectorAll('i')[nr];
    (function tick(z) {
      var p = Math.min(1, (laenge - rest + (jetzt() - t0)) / laenge);
      if (balken) balken.style.width = (p * 100).toFixed(1) + '%';
      if (p >= 1) { springe(1); return; }
      raf = window.requestAnimationFrame(tick);
    })(jetzt());
  }
  function stoppe() { if (raf) { window.cancelAnimationFrame(raf); raf = null; } }
  function anhalten() {
    if (pausiert) return;
    pausiert = true;
    rest = Math.max(0, rest - (jetzt() - t0));
    stoppe();
    knopfPause.innerHTML = '&#9654;';
    var v = buehneEl.querySelector('video'); if (v) v.pause();
  }
  function weiter() {
    if (!pausiert) return;
    var v = buehneEl.querySelector('video');
    if (v) { var l = v.play(); if (l && l.catch) l.catch(function () {}); }
    starte(laenge);
  }
  function springe(d) {
    var z = nr + d;
    if (z < 0) { zeige(0); return; }
    if (z >= folge.length) { zu(); return; }
    zeige(z);
  }
  function auf(idx, stueck) {
    stil(); huelle();
    var st = STORYS[idx];
    folge = st.folgen; aktTitel = st.titel;
    aktKreis = { stueck: stueck, idx: idx };
    titelEl.textContent = st.titel;
    balkenEl.innerHTML = st.folgen.map(function () {
      return '<span class="mmSEB"><i></i></span>';
    }).join('');
    fenster.classList.add('an');
    document.documentElement.style.overflow = 'hidden';
    rest = DAUER;
    zeige(0);
  }
  function zu() {
    stoppe();
    /* 23.08.2026, Mert: "das video soll nicht mehr laufen, also Ton aus, wenn
       man raus aus der Story ist". Seit es die Ton-Taste gibt (24.08.), ist das
       doppelt wichtig: sonst laeuft ein entstummtes Video im Hintergrund
       weiter. Quelle loesen, damit auch der Puffer stillsteht. */
    var v = buehneEl ? buehneEl.querySelector('video') : null;
    if (v) {
      try {
        v.pause();
        v.muted = true;
        v.currentTime = 0;
        v.removeAttribute('src');
        v.load();
      } catch (e) {}
    }
    if (buehneEl) buehneEl.innerHTML = '';
    /* Der Ton-Wunsch selbst bleibt bestehen - beim naechsten Oeffnen greift er
       wieder, ohne dass man ihn neu einschalten muss. */
    if (fenster) fenster.classList.remove('an');
    document.documentElement.style.overflow = '';
  }

  /* --- Leiste bauen und die App-Sektion ausblenden ------------------------ */
  function bauen() {
    if (document.getElementById('mmSE')) return true;
    var app = document.querySelector('[id*="st_insta_story"]');
    if (!app || !app.parentNode) return false;

    stil();
    /* Die App-Sektion bleibt im Theme, wird aber nicht mehr gezeigt. */
    app.style.setProperty('display', 'none', 'important');

    var s = document.createElement('section');
    s.id = 'mmSE';
    s.setAttribute('aria-label', 'Storys');
    s.innerHTML = '<div id="mmSEBahn">' + STORYS.map(function (st, i) {
      return '<button class="mmSEStueck" type="button" data-nr="' + i + '">' +
               '<span class="mmSEKreis">' +
                 '<img src="' + st.kreis + '" alt="' + st.titel + '" ' +
                 'decoding="async" width="150" height="150" fetchpriority="high">' +
                 /* Das Standbild bleibt darunter liegen: es ist sofort da und
                    traegt die Flaeche, falls ein Film nicht laedt oder im
                    App-Browser gar nicht erst startet. */
                 (st.film && st.film.length
                   ? '<video class="mmSEVor" muted playsinline loop preload="none" ' +
                     'aria-hidden="true" tabindex="-1"></video>'
                   : '') +
               '</span>' +
               '<span class="mmSEName">' + st.titel + '</span>' +
             '</button>';
    }).join('') + '</div>';

    app.parentNode.insertBefore(s, app);

    [].slice.call(s.querySelectorAll('.mmSEStueck')).forEach(function (b, i) {
      ringNeu(b, i);
      b.addEventListener('click', function () { auf(i, b); });
      /* Versatz je Kreis - daraus rechnet das Stilblatt die Verzoegerung. */
      b.style.setProperty('--mmSEi', i);
      /* Nach dem eigenen Lauf festschreiben (620 ms + 180 ms + Versatz). */
      window.setTimeout(function () { b.classList.add('fertig'); }, 820 + i * 95);
    });
    vorschauStarten(s);
    return true;
  }

  /* --- Bewegte Vorschau in den Kreisen ------------------------------------
     24.08.2026, Mert: "story vorschau die videos muessen abspielen in der
     vorschau" - und im selben Atemzug: "die videos duerfen aber nicht rein
     zoomen wenn man auf der seite ist, z.b. wenn man von tiktok reinkommt".
     Genau daran war die erste Fassung am 23.08. gescheitert: im eingebauten
     TikTok-Browser riss jeder Videostart das Bild ins Vollbild auf. Deshalb
     wurden die Filme damals ganz entfernt.
     Jetzt sind sie wieder da, aber mit der Bremse davor: `mm-vollbild.js`
     erkennt App-Browser (Bytedance/TikTok, Instagram, Facebook, Snapchat ...)
     und setzt `window.mmKeinAutoVideo`. Ist die Fahne gesetzt, laeuft hier
     NICHTS von selbst - es bleibt beim Standbild, genau wie bisher.
     FESTE REGEL 23.08.: nichts laeuft, wenn niemand hinsieht. Der Film haelt
     an, sobald die Leiste aus dem Bild ist oder das Fenster in den
     Hintergrund geht. */
  /* Wie lange ein Vorschau-Clip im Kreis stehen bleibt (Mert: alle 2-3 s). */
  var WECHSEL_MS = 2500;

  function vorschauStarten(wurzel) {
    if (window.mmKeinAutoVideo) return;                 /* TikTok & Co. */
    if (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var stuecke = [].slice.call(wurzel.querySelectorAll('.mmSEStueck'));
    var laeufer = [];

    stuecke.forEach(function (b, i) {
      var v = b.querySelector('.mmSEVor');
      var liste = STORYS[i] && STORYS[i].film;
      if (!v || !liste || !liste.length) return;

      var pos = 0, uhr = 0;

      function laden() {
        /* Kurz ausblenden, beim `playing` wieder ein - dadurch ist der Wechsel
           ein weiches Ueberblenden statt eines harten Schnitts. Bewegt wird
           nur die Deckkraft, das kostet praktisch keine Rechenzeit. */
        v.classList.remove('laeuft');
        v.src = THEMA + liste[pos % liste.length];
        var l = v.play();
        if (l && l.catch) l.catch(function () {});
      }

      function weiter() { pos++; laden(); }

      /* 29.08.2026, Mert: "ugc videos in der vorschau alle 2-3 sekunden
         wechseln." Vorher lief jeder Clip zu Ende - bei einem langen Video
         stand im Kreis minutenlang dasselbe Bild. Jetzt nach 2,5 s weiter;
         ist ein Clip kuerzer, schaltet `ended` schon vorher um und die Uhr
         kommt gar nicht zum Zug. */
      function planen() {
        window.clearTimeout(uhr);
        if (liste.length < 2) return;      /* nur ein Film: einfach laufen lassen */
        uhr = window.setTimeout(function () {
          if (document.hidden) return;     /* im Hintergrund wird nicht gewechselt */
          weiter();
        }, WECHSEL_MS);
      }

      function stoppen() { window.clearTimeout(uhr); uhr = 0; }

      v.addEventListener('ended', weiter);
      v.addEventListener('playing', function () { v.classList.add('laeuft'); planen(); });
      v.addEventListener('error', function () { v.classList.remove('laeuft'); stoppen(); });
      if (liste.length === 1) v.loop = true;

      laeufer.push({ v: v, laden: laden, planen: planen, stoppen: stoppen, gestartet: false });
    });

    if (!laeufer.length) return;

    var imBild = false;
    function nachfuehren() {
      var an = imBild && !document.hidden;
      laeufer.forEach(function (r) {
        if (an) {
          if (!r.gestartet) { r.gestartet = true; r.laden(); return; }
          if (r.v.paused) { var l = r.v.play(); if (l && l.catch) l.catch(function () {}); }
          r.planen();
        } else {
          /* Aus dem Bild oder Tab gewechselt: Film UND Uhr anhalten - sonst
             liefe die Vorschau unsichtbar weiter (feste Regel 23.08.2026). */
          r.stoppen();
          if (!r.v.paused) r.v.pause();
        }
      });
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        imBild = e.some(function (x) { return x.isIntersecting; });
        nachfuehren();
      }, { threshold: 0.25 }).observe(wurzel);
    } else {
      imBild = true;
      nachfuehren();
    }
    document.addEventListener('visibilitychange', nachfuehren);
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (bauen() || n > 25) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
  window.addEventListener('load', versuchen);
})();
